<template>
  <div>
    <a @click="openPreview" class="button is-info is-outlined">Preview</a>
  </div>
</template>
<script>
export default {
  name: 'preview',
  props: ['payload', 'additional_data'],
  methods: {
    openPreview () {
      this.$network_utils.updateOffer({ id: 1, status: 'admin_rejected', position_id: this.getPositionId() })
      let preview_link = this.getPreviewLink()
      this.$utils.openInNewTab(preview_link)
    },
    getPositionId () {
      if (this.additional_data.resource_type == 'Offer') {
        return this.payload.position.id
      }
      if (this.additional_data.resource_type == 'Position') {
        return this.payload.id
      }
    },
    getPreviewLink () {
      return this.$settings.get({ path: 'preview_link' }) + this.$utils.pseudoEncrypt(1)
    }
  }
}
</script>
